module.exports = __webpack_public_path__ + "img/activity-diagram.5084d896.svg";